/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PotentialCommissionSummaryDto } from '../models';
/**
 * RestCommissionPotentialApi - axios parameter creator
 */
export const RestCommissionPotentialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current user potential commission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPotentialCommission: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/commissions/potential`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCommissionPotentialApi - functional programming interface
 */
export const RestCommissionPotentialApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCommissionPotentialApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current user potential commission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserPotentialCommission(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PotentialCommissionSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserPotentialCommission(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCommissionPotentialApi.getCurrentUserPotentialCommission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCommissionPotentialApi - factory interface
 */
export const RestCommissionPotentialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCommissionPotentialApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current user potential commission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPotentialCommission(options?: RawAxiosRequestConfig): AxiosPromise<PotentialCommissionSummaryDto> {
            return localVarFp.getCurrentUserPotentialCommission(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCommissionPotentialApi - interface
 */
export interface RestCommissionPotentialApiInterface {
    /**
     * 
     * @summary Get current user potential commission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUserPotentialCommission(options?: RawAxiosRequestConfig): AxiosPromise<PotentialCommissionSummaryDto>;

}

/**
 * RestCommissionPotentialApi - object-oriented interface
 */
export class RestCommissionPotentialApi extends BaseAPI implements RestCommissionPotentialApiInterface {
    /**
     * 
     * @summary Get current user potential commission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUserPotentialCommission(options?: RawAxiosRequestConfig) {
        return RestCommissionPotentialApiFp(this.configuration).getCurrentUserPotentialCommission(options).then((request) => request(this.axios, this.basePath));
    }
}

